/** Fired on document.body when a request made outside htmx gets a response. */
export const SERVER_CONTACT_EVENT = 'servercontact';
